import * as ko from "knockout";
import { system, LookupStorage } from "portalframework";
import * as _ from "lodash";
import * as entities from "entities";
import { TaskManagementSearchCriteria } from "organized";
import { BaseService } from "./_common/_baseService";
import labels from "app/labels";
import { portalHttpService } from "./_common/httpService";

export enum DashboardPeriod {
  ALL = "0",
  MONTHS_3 = "3",
  MONTHS_6 = "6",
  MONTHS_12 = "12",
}

class DashboardService extends BaseService {
  constructor() {
    super("dashboard");
  }

  getDashboardScreenData = async (requiredLookups: string[]) => {
    let lookupsToFetch = _.difference(requiredLookups, LookupStorage.lookupStorage.lookupNames());
    let data = ko.toJSON({ requiredLookups: lookupsToFetch });
    const lookups = await portalHttpService.post<any>(`${this.baseApiUrl()}/GetDashboardScreenData`, data);

    this.setLookupData(lookupsToFetch, lookups.results);
  };

  getDashboardElement01 = async () => {
    const data = await portalHttpService.get<any[]>(`${this.baseApiUrl()}/GetDashboardElement01`);
    return data || [];
  };

  getDashboardElement02 = async (): Promise<any> => {
    const data = await portalHttpService.get<any>(`${this.baseApiUrl()}/GetDashboardElement02`);
    let dashboard = {};
    if (data) {
      if (data.c_portal_task_volume_dashboard_view) {
        dashboard["months"] = data.c_portal_task_volume_dashboard_view;
      } else {
        dashboard["months"] = [];
      }
      if (data.c_portal_task_volume_weeks_dashboard_view) {
        dashboard["weeks"] = data.c_portal_task_volume_weeks_dashboard_view;
      } else {
        dashboard["weeks"] = [];
      }
    }
    return dashboard;
  };

  getDashboardElement03 = async () => {
    const data = await portalHttpService.get<any[]>(`${this.baseApiUrl()}/GetDashboardElement03`);
    return data || [];
  };

  getDashboardElement04 = async () => {
    const data = await portalHttpService.get<any[]>(`${this.baseApiUrl()}/GetDashboardElement04`);
    return data || [];
  };

  getDashboardElement05 = async (startingDate: Date) => {
    const myUrlWithParams = new URL(`${this.baseApiUrl()}/GetDashboardElement05`);
    myUrlWithParams.searchParams.append("startingDate", startingDate.toISOString());
    return await portalHttpService.get<any>(myUrlWithParams.href);
  };

  private setLookupData = (lookupsToFetch: string[], results: any) => {
    _.each(lookupsToFetch, (lookupName) => {
      let list = results[lookupName];
      if (list) {
        if (lookupName == "PLACEPERSONS") {
          if (!Array.isArray(list.person)) {
            list["placepersons"] = [list["person"]];
          } else {
            list["placepersons"] = list["person"];
          }
          delete list["person"];
          _.each(list.placepersons, (p) => {
            p.description = p.first_name + " " + p.last_name;
            p.placepersons = p.person_id;
          });
        }

        LookupStorage.lookupStorage.add(new LookupStorage.Lookup(lookupName, list));
      }
    });
  };

  getStartingDate = (period: string) => {
    let fromDate: Date = null;
    if (period !== DashboardPeriod.ALL.toString()) {
      const periodNumber = +period;
      fromDate = new Date();
      fromDate.setMonth(new Date().getMonth() - periodNumber);
    } else {
      fromDate = new Date();
      fromDate.setFullYear(new Date().getFullYear() - 1);
    }
    fromDate.setHours(0, 0, 0, 0);

    return fromDate;
  };

  public exportFile = (
    criteria: TaskManagementSearchCriteria,
    headers: { label: string; css: KnockoutComputed<string>; sortMe: () => void }[],
    offset: any
  ): Promise<entities.SearchResult> => {
    return new Promise((resolve, reject) => {
      let url = "criteria=[" + ko.toJSON(criteria) + ",labels:";

      for (let header of headers) {
        url += labels.descr(header.label) + ",";
      }
      if (url.endsWith(",")) {
        url = url.substring(0, url.length - 1);
      }
      url += "}timeZone:" + offset;
      url += "]";
      window.open(system.apiURL() + "api/dashboard/exportTasksFile?" + url);
      resolve(null);
    });
  };
}

export const dashboardService = new DashboardService();
